export default __webpack_public_path__ + "static/media/bk-tomato-food.eba5156c.png";